import React, { useEffect } from "react";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useState } from "react";
import CryptoJS from "crypto-js";
import {
  useGetBenchLocationsMutation,
  useSubmitCaseStatusMutation,
  useSendCaptchaMutation,
  useGetApplicationTypesMutation,
} from "../../../../redux/services/external/apiExternal";
import {
  generateCaptcha,
  generateCaptchaImage,
} from "../../../../Utility/GenerateCaptcha";
import CaseStatusModal from "./CaseStatusModal";
import { useParams } from "react-router-dom";
import { RctBenches } from "../../../../Benches/Benches";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faVolumeUp } from "@fortawesome/free-solid-svg-icons";
import DailyOrderModal from "./DailyOrderModal";

const DailyOrder = () => {
  const { benchId } = useParams();
  const numericBenchId = Number(benchId);
  const bench = RctBenches.find((bench) => bench.id === numericBenchId);
  const benchCode = bench ? bench.railway_bench_code : null;

  // console.log("benchCode is", benchCode);

  // Generate Captcha
  const [captcha, setCaptcha] = useState(generateCaptcha());
  // console.log("captcha is ", captcha);

  // Generate image for the initial captcha
  const [captchaImage, setCaptchaImage] = useState(
    generateCaptchaImage(captcha)
  );

  // Track CAPTCHA verification status
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  // Warning message for CAPTCHA
  const [captchaWarning, setCaptchaWarning] = useState("");

  //   const encryptedStringx = CryptoJS.SHA512("ZlZdvr").toString();
  // console.log("Encrypted String:", 9827c223cf04e48634cb40780a3e60291f8d9dc60187b3182039706e7045e9003e8fb5fbcd75dccc12a2b7c56a10872187c3f1dcd4963c57cb3aaffde358bcaf);

  const [disableFilingNo, setDisableFilingNo] = useState(false);
  const [disableOtherInputs, setDisableOtherInputs] = useState(false);
  const [railwayBenchCode, setRailwayBenchCode] = useState(benchCode);

  const [selectionType, setSelectionType] = useState(
    disableFilingNo ? "case_no_wise" : "filing_no_wise"
  );

  const [sendCaptcha, { data: updateCaptchaResponse }] =
    useSendCaptchaMutation();

  // bench locations
  const [getBenchLocations, { data, error, isLoading }] =
    useGetBenchLocationsMutation();

  // application types
  const [getApplicationTypes, { data: applicationTypesData }] =
    useGetApplicationTypesMutation();
  // console.log(" applicationTypesData  ", applicationTypesData);

  const [
    submitCaseStatus,
    { data: responseCaseStatus, isLoading: isSubmitting, error: submitError },
  ] = useSubmitCaseStatusMutation();
  // console.log(" responseCaseStatus  ", responseCaseStatus);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [resetFormFunction, setResetFormFunction] = useState(null);

  useEffect(() => {
    sendCaptcha({ captchaCode: captcha, username: "public" });
    setCaptchaImage(generateCaptchaImage(captcha));
  }, [captcha]);

  useEffect(() => {
    const fetchBenchLocations = async () => {
      try {
        await getBenchLocations().unwrap();
      } catch (err) {
        console.error("Error fetching bench locations:", err);
      }
    };
    fetchBenchLocations();
  }, [getBenchLocations]);

  useEffect(() => {
    if (disableFilingNo) setSelectionType("case_no_wise");
    else setSelectionType("filing_no_wise");
  }, [disableFilingNo]);

  const initialValues = {
    filingNo: "",
    caseNo: "",
    caseYear: "",
    caseType: "",
    applicationType: "",
    benchLocation: benchId,
    captchaCode: "",
  };

  // Validation Schema with length constraints
  const validationSchema = Yup.object({
    filingNo: Yup.string().when(
      ["caseNo", "caseYear", "caseType", "applicationType"],
      {
        is: (caseNo, caseYear, caseType, applicationType) =>
          !caseNo && !caseYear && !caseType && !applicationType,
        then: Yup.string()
          .required("Filing Number is required if no other field is selected")
          .matches(/^\d+$/, "Filing Number must be a number")
          .max(20, "Filing Number cannot exceed 20 characters"),
      }
    ),
    caseNo: Yup.string()
      .matches(/^\d+$/, "Case Number must be a number")
      .max(20, "Case Number cannot exceed 20 characters"),
    caseYear: Yup.string(),
    caseType: Yup.string(),
    applicationType: Yup.string(),
    benchLocation: Yup.string(),
    captchaCode: Yup.string()
      .required("Captcha is required")
      .matches(/^[A-Z0-9]+$/, "Invalid Captcha")
      .max(6, "Captcha Code cannot exceed 6 characters"),
  });

  const [errorString, setErrorString] = useState("");

  const handleSubmit = async (values, { resetForm }) => {
    // console.log("Case Status form values: ", values);
    setResetFormFunction(() => resetForm);

    // Get the current date
    const currentDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format

    // Combine captchaCode with the date
    const datedCaptcha = values.captchaCode + currentDate;

    // Encrypt the saltedCaptcha using SHA-512
    const encryptedCaptcha = CryptoJS.SHA512(datedCaptcha).toString();

    let payload;
    if (disableFilingNo) {
      payload = {
        filing_no: "",
        search_type: selectionType,
        case_no: values.caseNo,
        case_year: values.caseYear,
        case_type: values.caseType,
        // appl_case_type: values.applicationType,
        appl_case_type: null,
        location: railwayBenchCode,
        // captcha: values.captchaCode
        captcha: encryptedCaptcha,
        // captcha: "9827c223cf04e48634cb40780a3e60291f8d9dc60187b3182039706e7045e9003e8fb5fbcd75dccc12a2b7c56a10872187c3f1dcd4963c57cb3aaffde358bcaf"
      };
    } else {
      payload = {
        search_type: selectionType,
        filing_no: values.filingNo,
        location: railwayBenchCode,
        // captcha: values.captchaCode
        captcha: encryptedCaptcha,
        // captcha: "25684d7f4f9f870b41bf0c061cfd96a1b5a35e9cf72a5c836e63bb80eebb2f988248a27bca04205a3254939f1b40cf5650a34749d0693910e412fc3d30f59956"
      };
    }

    try {
      const result = await submitCaseStatus(payload).unwrap();

      if (result.error !== "") {
        setErrorString(result.error);
        setModalIsOpen(true); // Open modal if there's an error
      } else {
        resetForm();
        setDisableFilingNo(false); // Reset after submit
        setDisableOtherInputs(false); // Reset after submit
        setModalIsOpen(true); // Open modal for success
      }
    } catch (err) {
      console.error("Error submitting case status:", err);
    }
  };

  const handleCaptchaChange = (e) => {
    const enteredCaptcha = e.target.value;
    if (enteredCaptcha === captcha) {
      setIsCaptchaVerified(true); // Set verified if CAPTCHA matches
      setCaptchaWarning(""); // Clear warning message
    } else {
      setIsCaptchaVerified(false); // Set unverified if CAPTCHA doesn't match
    }
  };

  const handleReset = () => {
    // if (resetFormFunction) {
    resetFormFunction();
    setDisableFilingNo(false);
    setDisableOtherInputs(false);
    setCaptcha(generateCaptcha());
    setCaptchaImage(generateCaptchaImage(captcha));
    setIsCaptchaVerified(false);
    setCaptchaWarning("");
    setErrorString("");
    // }
  };

  const handleModalClose = () => {
    if (resetFormFunction) {
      resetFormFunction();
      setDisableFilingNo(false);
      setDisableOtherInputs(false);
      setCaptcha(generateCaptcha());
      setCaptchaImage(generateCaptchaImage(captcha));
      setIsCaptchaVerified(false);
      setCaptchaWarning("");
      setErrorString("");
    }
  };

  const handleSubmitClick = () => {
    if (!isCaptchaVerified) {
      setCaptchaWarning("Please enter a valid CAPTCHA."); // Set warning message when CAPTCHA is invalid
    }
  };

  return (
    <>
      <div className="about-content">
        {/* <h6>Welcome to</h6> */}
        {/* <div className="underline"></div> */}
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit, handleChange, handleBlur, values, resetForm }) => (
            <Form onSubmit={handleSubmit}>
              <Row>
                {/* Filing No Input */}
                <Col md={6}>
                  <Form.Group controlId="filingNo" className="form-group">
                    <Form.Label>Filing Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="filingNo"
                      placeholder="Enter Filing Number"
                      value={values.filingNo}
                      onChange={(e) => {
                        handleChange(e);
                        if (e.target.value) {
                          setDisableOtherInputs(true); // Disable other fields when Filing No is filled
                        } else {
                          setDisableOtherInputs(false); // Re-enable other fields if Filing No is cleared
                        }
                      }}
                      onBlur={handleBlur}
                      disabled={disableFilingNo}
                    />
                    <ErrorMessage
                      name="filingNo"
                      component="div"
                      style={{ color: "red", fontSize: "0.8rem" }}
                    />
                  </Form.Group>
                </Col>

                {/* Case No Input */}
                <Col md={6}>
                  <Form.Group controlId="caseNo" className="form-group">
                    <Form.Label>Case Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="caseNo"
                      placeholder="Enter Case Number"
                      value={values.caseNo}
                      onChange={(e) => {
                        handleChange(e);
                        if (e.target.value) {
                          setDisableFilingNo(true);
                        }
                      }}
                      onBlur={handleBlur}
                      disabled={disableOtherInputs}
                    />
                    <ErrorMessage
                      name="caseNo"
                      component="div"
                      style={{ color: "red", fontSize: "0.8rem" }}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="caseYear" className="form-group">
                    <Form.Label>Case Year</Form.Label>
                    <Form.Control
                      as="select"
                      name="caseYear"
                      value={values.caseYear}
                      onChange={(e) => {
                        handleChange(e);
                        if (e.target.value) {
                          setDisableFilingNo(true);
                        }
                      }}
                      onBlur={handleBlur}
                      disabled={disableOtherInputs}
                    >
                      <option value="">Select Year</option>
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="caseType" className="form-group">
                    <Form.Label>Main Case Type</Form.Label>
                    <Form.Control
                      as="select"
                      name="caseType"
                      value={values.caseType}
                      onChange={(e) => {
                        handleChange(e);
                        if (e.target.value) {
                          setDisableFilingNo(true);
                        }
                        getApplicationTypes({
                          ref_claim_code: "3",
                          login_id: "undefined | undefined | undefined",
                        });
                      }}
                      onBlur={handleBlur}
                      disabled={disableOtherInputs}
                    >
                      <option value="">Select Case Type</option>
                      <option value="101">
                        Application Form I(COMPENSATION FOR LOSS ETC OF BOOKED
                        CONSIGNMENT)
                      </option>
                      <option value="201">
                        Application Form II(COMPENSATION FOR TRAIN ACCIDENT)
                      </option>
                      <option value="301">
                        Application Form II(COMPENSATION FOR TRAIN UNTOWARD
                        INCIDENT)
                      </option>
                      <option value="401">
                        Application Form III(COMPENSATION FOR REFUND OF FARE)
                      </option>
                      <option value="501">
                        Application Form III(COMPENSATION FOR REFUND OF FREIGHT)
                      </option>
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group
                    controlId="applicationType"
                    className="form-group"
                  >
                    <Form.Label>Select Application Type</Form.Label>
                    <Form.Control
                      as="select"
                      name="applicationType"
                      value={values.applicationType}
                      onChange={(e) => {
                        handleChange(e);
                        if (e.target.value) {
                          setDisableFilingNo(true);
                        }
                      }}
                      onBlur={handleBlur}
                      disabled={disableOtherInputs}
                    >
                      <option value={null}>Application Type</option>
                      {applicationTypesData?.appl_case_type.length > 0 ? (
                        applicationTypesData?.appl_case_types?.map(
                          (applicationType) => (
                            <option
                              key={applicationType.case_type_code}
                              value={applicationType.case_type_code}
                            >
                              {applicationType.appl_name}
                            </option>
                          )
                        )
                      ) : (
                        <option>Not Found</option>
                      )}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="benchLocation" className="form-group">
                    <Form.Label>Select Bench Location</Form.Label>
                    <Form.Control
                      as="select"
                      name="benchLocation"
                      value={values.benchLocation}
                      onChange={(e) => {
                        handleChange(e);
                        // if (e.target.value) {
                        //   setDisableFilingNo(true);
                        // }

                        const selectedIndex = e.target.selectedIndex; // Get selected index
                        const selectedBench = data?.data?.[selectedIndex - 1]; // Access bench by index (-1 because of default option)
                        setRailwayBenchCode(selectedBench.railway_bench_code);
                      }}
                      onBlur={handleBlur}
                      // disabled={disableOtherInputs}
                    >
                      <option value={null}>Bench Location</option>
                      {isLoading && <div>Loading benches...</div>}
                      {error && <div>Error loading benches</div>}
                      {data?.data?.length > 0 ? (
                        data?.data?.map((bench) => (
                          <option key={bench.id} value={bench.id}>
                            {bench.railway_bench_name}
                          </option>
                        ))
                      ) : (
                        <option>Not Found</option>
                      )}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={3} className="text-left">
                  <Form.Group controlId="captcha" className="form-group pt-3">
                    {/* <Form.Label>Captcha</Form.Label> */}
                    <img
                      src={captchaImage}
                      alt="Captcha"
                      className="mr-3 mb-3"
                    />

                    {/* Refresh Icon */}
                    <FontAwesomeIcon
                      icon={faSyncAlt}
                      onClick={() => {
                        const newCaptcha = generateCaptcha();
                        setCaptcha(newCaptcha);
                        setCaptchaImage(generateCaptchaImage(newCaptcha));
                      }}
                      style={{
                        cursor: "pointer",
                        marginRight: "10px",
                        fontSize: "24px",
                      }}
                    />

                    {/* Audio Icon */}
                    <FontAwesomeIcon
                      icon={faVolumeUp}
                      onClick={() => {
                        const utterance = new SpeechSynthesisUtterance(captcha);
                        utterance.rate = 0.5;
                        window.speechSynthesis.speak(utterance);
                      }}
                      style={{ cursor: "pointer", fontSize: "24px" }}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="captchaCode" className="form-group">
                    <Form.Label>Enter Captcha</Form.Label>
                    <Form.Control
                      type="text"
                      name="captchaCode"
                      placeholder="Enter Captcha"
                      value={values.captchaCode}
                      onChange={(e) => {
                        handleChange(e);
                        handleCaptchaChange(e); // Check CAPTCHA verification
                      }}
                      onBlur={handleBlur}
                    ></Form.Control>
                    <ErrorMessage
                      name="captchaCode"
                      component="div"
                      style={{ color: "red", fontSize: "0.8rem" }}
                    />
                  </Form.Group>
                </Col>

                <Col md={12} className="text-center mt-4">
                  <Button
                    type="submit"
                    className="btn yellow-btn mr-2"
                    disabled={!isCaptchaVerified || isSubmitting} // Disable until CAPTCHA is verified
                    onClick={handleSubmitClick} // Handle button click to show warning
                  >
                    Submit
                  </Button>
                  <Button
                    className="grey-btn btn btn-secondary"
                    onClick={() => {
                      resetForm();
                      setDisableFilingNo(false);
                      setDisableOtherInputs(false);
                      setCaptcha(generateCaptcha());
                      setCaptchaImage(generateCaptchaImage(captcha));
                      setIsCaptchaVerified(false);
                      setCaptchaWarning("");
                      setErrorString("");
                    }}
                  >
                    Reset
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>

      <DailyOrderModal
        responseCaseStatus={responseCaseStatus}
        submitError={submitError}
        errorString={errorString}
        show={modalIsOpen}
        handleClose={() => {
          setModalIsOpen(false);
          handleModalClose();
        }}
      />
    </>
  );
};

export default DailyOrder;
